export interface GetTasksParams {
  projectId: string
}

export interface GetTaskParams extends GetTasksParams {
  taskId: string
}

export interface GetTaskToolParams extends GetTaskParams {
  toolId: string
}

export const GET_TASK_TOOL_PART_CODES = {
  introduction: 'introduction',
  main_customer_problems: 'main_customer_problems',
  main_customer_wishes: 'main_customer_wishes',
  main_customer_profits: 'main_customer_profits',
  conclusions: 'conclusions',
} as const

export const GET_TASK_TOOL_PART_TYPES = {
  video: 'video',
  table: 'table',
  form: 'form',
  html: 'html',
} as const

export interface GetTaskToolPartParams extends GetTaskToolParams {
  part: string
}

export interface GetTaskToolPartDataParams {
  projectId: string
  toolId: string
  part: string
}
export interface SaveTaskToolPartDataParams {
  projectId: string
  toolId: string
  part: string
}
export interface GetTaskToolPartRecommandationsParams extends GetTaskToolPartParams {}

export interface SaveTaskToolPartUserAnswerToBotQuestionParams extends GetTaskToolPartParams {
  questionId: string
}

export interface SendTaskToolPartBotMessageParams {}

export interface SaveTaskConclusionParams extends GetTaskParams {}

export interface CreateToolParams {
  projectId: string
}

export interface GetToolParams {
  toolCode: string
}

export interface GetToolPartParams {
  projectId: string
  toolId: string
  part: string
}

const endpoints = {
  getAvailableTasks: 'api/v2/tasks/',
  getTasks: ({ projectId }: GetTasksParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/tasks`
  },
  getTask: ({ projectId, taskId }: GetTaskParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/tasks/${taskId}`
  },
  getTaskTool: ({ projectId, taskId, toolId }: GetTaskToolParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/tasks/${taskId}/tools/${toolId}`
  },
  getTaskToolPart: ({ projectId, taskId, toolId, part }: GetTaskToolPartParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/tasks/${taskId}/tools/${toolId}/parts/${part}`
  },
  getTaskToolPartData: ({ projectId, toolId, part }: GetTaskToolPartDataParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/tools/${toolId}/parts/${part}/data`
  },
  saveTaskToolPartData: ({ projectId, toolId, part }: SaveTaskToolPartDataParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/tools/${toolId}/parts/${part}/data`
  },
  getTaskHypothesisRecommendations: ({ projectId, taskId }: GetTaskParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/tasks/${taskId}/hypothesis/recommendations`
  },
  getTaskToolPartRecommandations: ({
    projectId,
    taskId,
    toolId,
    part,
  }: GetTaskToolPartRecommandationsParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/tasks/${taskId}/tools/${toolId}/parts/${part}/recommendations`
  },
  saveTaskToolPartUserAnswerToBotQuestion: ({
    projectId,
    taskId,
    toolId,
    part,
    questionId,
  }: SaveTaskToolPartUserAnswerToBotQuestionParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/tasks/${taskId}/tools/${toolId}/parts/${part}/questions/${questionId}/answer`
  },
  sendTaskToolPartBotMessage: ({}: SendTaskToolPartBotMessageParams): string => `api/v2/socket/messages`,
  saveTaskConclusion: ({ projectId, taskId }: SaveTaskConclusionParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/tasks/${taskId}/conclusions`
  },
  createTool: ({ projectId }: CreateToolParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/tools`
  },
  getTool: ({ toolCode }: GetToolParams): string => {
    return `api/v2/tools/${toolCode}`
  },
  getToolPart: ({ projectId, toolId, part }: GetToolPartParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/tools/${toolId}/parts/${part}`
  },
}

export default endpoints
